var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5101 0C17.908 0 19.8 1.958 19.8 5.313V16.676C19.8 20.086 17.908 22 14.5101 22H5.291C1.947 22 0 20.086 0 16.676V5.313C0 1.958 1.947 0 5.291 0H14.5101ZM5.588 15.114C5.258 15.081 4.939 15.235 4.763 15.521C4.587 15.796 4.587 16.159 4.763 16.445C4.939 16.72 5.258 16.885 5.588 16.841H14.212C14.6509 16.797 14.982 16.4219 14.982 15.983C14.982 15.532 14.6509 15.158 14.212 15.114H5.588ZM14.212 10.0969H5.588C5.1139 10.0969 4.73 10.483 4.73 10.956C4.73 11.429 5.1139 11.814 5.588 11.814H14.212C14.685 11.814 15.07 11.429 15.07 10.956C15.07 10.483 14.685 10.0969 14.212 10.0969ZM8.8759 5.115H5.588V5.126C5.1139 5.126 4.73 5.511 4.73 5.984C4.73 6.457 5.1139 6.842 5.588 6.842H8.8759C9.35 6.842 9.735 6.457 9.735 5.9719C9.735 5.5 9.35 5.115 8.8759 5.115Z",
    fill: "#9488A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ca1ac25ab4531189274b8143239bc04a.svg";
export { ForwardRef as ReactComponent };